<template>
  <div class="print-wrapper">
    <!-- 产品信息表格 -->
    <table class="info-table">
      <tbody>
        <tr>
          <td class="info-label">产品编号</td>
          <td class="info-value">{{ tableData.productCode }}</td>
          <td class="info-label">产品属性</td>
          <td class="info-value">{{ tableData.productAttr }}</td>
          <td rowspan="4" class="product-image">
            <img v-if="tableData.productImage" :src="tableData.productImage" alt="产品图片" />
          </td>
        </tr>
        <tr>
          <td class="info-label">产品名称</td>
          <td class="info-value">{{ tableData.productName }}</td>
          <td class="info-label">单位</td>
          <td class="info-value">{{ tableData.unit }}</td>
        </tr>
        <tr>
          <td class="info-label">产品规格</td>
          <td class="info-value">{{ tableData.spec }}</td>
          <td class="info-label">数量</td>
          <td class="info-value">{{ tableData.quantity }}</td>
        </tr>
        <tr>
          <td class="info-label">备注</td>
          <td colspan="3" class="info-value">{{ tableData.remark }}</td>
        </tr>
      </tbody>
    </table>

    <!-- 物料清单表格 -->
    <table class="material-table">
      <thead>
        <tr>
          <th colspan="7" class="table-title">物料清单</th>
        </tr>
        <tr>
          <th width="60">序号</th>
          <th>物料名称</th>
          <th>物料属性</th>
          <th>规格</th>
          <th>单位</th>
          <th>数量</th>
          <th>备注</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in tableData.materialList" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.attr }}</td>
          <td>{{ item.spec }}</td>
          <td>{{ item.unit }}</td>
          <td>{{ item.quantity }}</td>
          <td>{{ item.remark }}</td>
        </tr>
      </tbody>
    </table>

    <!-- 工艺路线表格 -->
    <table class="process-table">
      <tbody>
        <tr>
          <td class="process-label">工艺路线</td>
          <td class="process-content">
            <div class="process-flex">
              <div
                v-for="(step, index) in tableData.processRoute"
                :key="index"
                :class="['process-step', { active: index === tableData.currentStep }]"
              >
                <span class="step-circle">{{ step.num }}</span>
                <span class="step-name">{{ step.name }}</span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 物料采购表格 -->
    <table class="purchase-table">
      <thead>
        <tr>
          <th width="60" rowspan="2">上一工序</th>
          <th colspan="7">当前工序</th>
          <th width="60" rowspan="2">下一工序</th>
        </tr>
        <tr>
          <th>名称</th>
          <th>规格</th>
          <th>单位</th>
          <th>数量</th>
          <th>领料数</th>
          <th>报工数</th>
          <th>仓位</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in tableData.purchaseList" :key="index">
          <td>{{ item.prevProcess }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.spec }}</td>
          <td>{{ item.unit }}</td>
          <td>{{ item.quantity }}</td>
          <td>{{ item.issuedQty }}</td>
          <td>{{ item.reportedQty }}</td>
          <td>{{ item.location }}</td>
          <td>{{ item.nextProcess }}</td>
        </tr>
      </tbody>
    </table>

    <!-- 质检要求表格 -->
    <table class="inspection-table">
      <thead>
        <tr>
          <th colspan="4" class="table-title">质检要求</th>
        </tr>
        <tr>
          <th>序号</th>
          <th>检测项目</th>
          <th>标准范围</th>
          <th>检测结果</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in tableData.inspectionList" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.item }}</td>
          <td>{{ item.standardRange }}</td>
          <td>{{ item.result }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'PrintTable',
  data() {
    return {
      // 表格数据配置，key值固定，val值可修改，demo数据后期替换
      tableData: {
        // 产品信息
        productCode: '-',
        productAttr: '半成品',
        productName: '杯柄',
        unit: '件',
        spec: '10*1*600',
        quantity: '100',
        remark: '',
        productImage: '',

        // 当前工序索引
        currentStep: 0,

        // 物料清单
        materialList: [
          {
            name: '304圆管',
            attr: '原材料',
            spec: '10*1*600',
            unit: '支',
            quantity: '10',
            remark: ''
          }
        ],

        // 工艺路线
        processRoute: [
          { name: '激光切管', num: 1 },
          { name: '弯管', num: 2 },
          { name: '拉丝表面', num: 3 },
          { name: '打磨抛光', num: 4 },
          { name: '打包', num: 5 }
        ],

        // 物料采购
        purchaseList: [
          {
            prevProcess: '',
            name: '激光切管',
            spec: '10*1*600',
            unit: '支',
            quantity: '100',
            issuedQty: '',
            reportedQty: '',
            location: '',
            nextProcess: '弯管'
          }
        ],

        // 质检要求
        inspectionList: [
          { item: '', standardRange: '', result: '' },
          { item: '', standardRange: '', result: '' },
          { item: '', standardRange: '', result: '' },
          { item: '', standardRange: '', result: '' },
          { item: '', standardRange: '', result: '' }
        ]
      }
    }
  }
}
</script>

<style lang="less" scoped>
.print-wrapper {
}

// 产品信息表格
.info-table {
  width: 100%;
  border-collapse: collapse;

  td {
    border: 1px solid #000;
    padding: 4px;
    font-size: 12px;
  }

  .info-label {
    width: 60px;
    background: #e0e5eb;
    font-weight: bold;
  }

  .info-value {
    min-width: 100px;
  }

  .product-image {
    width: 150px;
    text-align: center;
    vertical-align: middle;

    img {
      max-width: 140px;
      max-height: 140px;
      object-fit: contain;
    }
  }
}

// 物料清单表格
.material-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: -1px;

  th,
  td {
    border: 1px solid #000;
    padding: 4px;
    font-size: 12px;
    text-align: center;
  }

  th {
    font-weight: bold;
    background: #e0e5eb;
  }

  .table-title {
    text-align: left;
    background: #e0e5eb;
  }
}

// 工艺路线表格
.process-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: -1px;

  td {
    border: 1px solid #000;
    padding: 4px;
    font-size: 12px;
  }

  .process-label {
    width: 60px;
    background: #e0e5eb;
    font-weight: bold;
  }

  .process-content {
    .process-flex {
      display: flex;
      align-items: center;
      gap: 4px;
      flex-wrap: wrap;
    }
  }

  .process-step {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    background: #eee;
    border-radius: 4px;

    &.active {
      background: @colorRed;
      color: #fff;

      .step-circle {
        background: #fff;
        color: @colorRed;
      }
    }

    .step-circle {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: #bbb;
      color: #333;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 10px;
      font-weight: bold;
    }

    .step-name {
      font-size: 12px;
    }
  }
}

// 物料采购表格
.purchase-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: -1px;

  th,
  td {
    border: 1px solid #000;
    padding: 4px;
    font-size: 12px;
    text-align: center;
  }

  th {
    font-weight: bold;
    background: #e0e5eb;
  }
}

// 质检要求表格
.inspection-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: -1px;

  th,
  td {
    border: 1px solid #000;
    padding: 4px;
    font-size: 12px;
    text-align: center;
  }

  th {
    font-weight: bold;
    background: #e0e5eb;
  }

  .table-title {
    text-align: left;
    background: #e0e5eb;
  }
}
</style>
